import Dropzone from "react-dropzone";
import React, { useState } from "react";
import { Button } from "@mui/material";
import { CloudUpload as CloudUploadIcon } from "@mui/icons-material";

import "./Dropzone.css";
import clsx from "clsx";

const FileDropzone = ({
  onDrop,
  multiple = true,
  content,
  style = {},
  allowedFileTypes = [],
  fileSizeLimit = null,
}) => {
  const [fileDrag, setFileDrag] = useState(false);

  const handleDragEnter = (e) => {
    e.preventDefault();
    setFileDrag(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setFileDrag(false);
  };

  const dropClasses = clsx("dropzone", {
    "dropzone--active": fileDrag,
  });

  return (
    <Dropzone
      onDragEnter={handleDragEnter}
      onDragLeave={(e) => handleDragLeave(e)}
      onDrop={onDrop}
      multiple={multiple}
      accept={allowedFileTypes}
    >
      {({ getRootProps, getInputProps }) => {
        return (
          <div {...getRootProps()} className={dropClasses} style={style}>
            <div
              style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <CloudUploadIcon
                style={{
                  fontSize: 58,
                  color: "#C6C6C6",
                }}
              />
              {content}

              <Button variant="contained" color="secondary">
                Select File/s
              </Button>
              {fileSizeLimit && (
                <span style={{ color: "#757575" }}>
                  File size limit: {fileSizeLimit}
                </span>
              )}
            </div>
            <input {...getInputProps()} />
          </div>
        );
      }}
    </Dropzone>
  );
};

export default FileDropzone;
